import type { FlexProps } from '@chakra-ui/react';
import { Box, Flex, HStack, Text, VStack } from '@chakra-ui/react';
import type { AddressOrNative } from '@cronos-app/sdk';
import type { Token } from '@ui/config/token';
import { useTokenConfig } from '@ui/hooks/contracts/useTokenConfig';
import { type ReactNode } from 'react';

import { MaskIcon } from '../MaskIcon';

type TokenSelectorProps = FlexProps & {
  token: Token;
  tokenAddress?: AddressOrNative;
  footer?: ReactNode;
};
export const TokenSelector = ({
  token,
  footer,
  tokenAddress,
  ...props
}: TokenSelectorProps) => {
  const tokenInfo = useTokenConfig({
    token,
    tokenAddress,
  });

  return (
    <Flex
      flex="1"
      justify="center"
      alignItems="center"
      bg="secondary.persianBlue"
      py="4px"
      px="4px"
      cursor={props.onClick ? 'pointer' : undefined}
      roundedRight="8px"
      color="background.offWhite"
      {...props}
    >
      <VStack gap="4px">
        <HStack alignItems="center" gap="8px">
          {tokenInfo?.Icon && (
            <tokenInfo.Icon
              boxSize={{
                base: '16px',
                desktop: '24px',
              }}
              rounded="full"
            />
          )}
          <Text lineClamp={2} textStyle="body2Bold" wordBreak="break-all">
            {tokenInfo?.symbol || '--'}
          </Text>
          {!!props.onClick && (
            <MaskIcon
              icon="url(/masks/chevron.svg)"
              bg="white"
              boxSize={{
                base: '16px',
                desktop: '24px',
              }}
            />
          )}
        </HStack>
        {footer && (
          <Box
            textStyle="caption"
            _firstLetter={{
              textTransform: 'capitalize',
            }}
            color="secondary.orange"
          >
            {footer}
          </Box>
        )}
      </VStack>
    </Flex>
  );
};
